import type {TContent, TMediaGalleryItemType, TMediaLibraryTab} from "@/store/types";
import dayjs from "dayjs";

const CONTENT_TYPES: Record<TMediaLibraryTab, TMediaGalleryItemType> = {
  instagram: "INSTAGRAM",
  source: "SOURCE",
  tiktok: "TIKTOK",
  ugc: "UGC",
};

/**
 * The date a piece of content should be shown under.
 *
 * "timestamp" is when the post went live on the platform; "created" is when our sync first
 * ingested the row, which can trail publication by weeks on backfilled media. Prefer the
 * former and fall back to the latter for UGC and source material, which are never published
 * anywhere and so only have an upload date. TikTok's "create_time" is normalised into
 * "timestamp" upstream, in the gallery store.
 */
const getContentPublishedDate = ({
  media,
}: {
  media?: {created?: string | null; timestamp?: string | null} | null;
}): string | null => media?.timestamp || media?.created || null;

const getContentPermalink = ({
  media,
}: {
  media?: {
    created?: string | null;
    media_product_type?: TContent | null;
    permalink?: string | null;
    timestamp?: string | null;
  } | null;
}): string | null => {
  if (!media?.permalink || media.media_product_type === "SOURCE" || media.media_product_type === "UGC") {
    return null;
  }

  if (media.media_product_type === "STORY") {
    const publishedAt = getContentPublishedDate({media});

    if (!publishedAt || dayjs().diff(publishedAt, "hour") >= 24) {
      return null;
    }
  }

  return media.permalink;
};

export {CONTENT_TYPES, getContentPermalink, getContentPublishedDate};
